import { stegaClean } from '@/lib/utils/stega';

export function resolveAnchor(anchor?: string | null) {
    if (!anchor) return undefined;

    const cleaned = stegaClean(anchor).trim();
    return cleaned || undefined;
}
